'use strict';/* global define */define('modules/custom-forms/services/custom-builder-form-preview/index',['require','exports','module','text!./template.html'],function(require,exports,module){'use strict';// @ngInject
factory.$inject = ["$resource", "API_ENDPOINT", "btfModal", "Modals"];
function factory($resource,API_ENDPOINT,btfModal,Modals){// jshint latedef:false
var resource=$resource(API_ENDPOINT+'forms/:id/preview');var resourceFormRevision=$resource(API_ENDPOINT+'forms/revision/:id/preview');return{show:show,showRevision:showRevision};// ---
/**
     * Fetch preview data for form revision with given form revision Id
     * and open Model to display it
     *
     * @param {Number} formRevisionId - Id of form revision
     */function showRevision(formRevisionId){resourceFormRevision.get({id:formRevisionId}).$promise.then(function(data){_showInModal(data);}).catch(function(reason){Modals.fail(reason);});}/**
     * Fetch preview data for form with given Id
     * and open Model to display it
     *
     * @param  {Number|Object} idOrForm - Id of form or form itself
     *
     * @tested
     */function show(idOrForm){if(typeof idOrForm==='number'){resource.get({id:idOrForm}).$promise.then(function(data){_showInModal(data);}).catch(function(reason){Modals.fail(reason);});}else{_showInModal(idOrForm);}}/**
     * Show form inside of a modal
     *
     * @param  {Object} form - Form to show
     *
     * @tested
     */function _showInModal(form){var modal=btfModal({// @ngInject
controller:["$scope", function controller($scope){$scope.close=modal.deactivate;$scope.form=form;}],template:require('text!./template.html')});modal.activate();}}module.exports=factory;});
